<template>
  <naj-modal
    ref="modal"
    :title="local.changeAuditPath.modalTitle"
    :width="900"
    :footer="true"
    @onClose="closeModal"
  >
    <form class="change-path-form">
      <naj-input
        :type-id="formFieldType.selectbox"
        :items="auditPaths"
        :value.sync="pathId"
        item-text="name"
        item-value="id"
        :label="local.changeAuditPath.selectEmployee"
      ></naj-input>
    </form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        :disabled="pathId == null || loading"
        :loading="loading"
        @click="submit(closeNajModal)"
      >
        {{ local.common.save }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  name: 'ChangePathModal',
  props: ['modalVisibility', 'selectedRequests'],
  data () {
    return {
      pathId: null,
      loading: false,
    };
  },
  mounted () {},
  computed: {
    ...mapLUTState(['auditPaths']),
  },
  methods: {
    ...mapActions(['changeAuditPaths']),
    ...mapLUTActions(['getAuditPaths']),
    callGetAuditPaths () {
      this.getAuditPaths();
    },
    closeModal () {
      this.$emit('onClose');
      this.resetForm();
    },
    submit () {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loading = true;
          const payload = this.selectedRequests.reduce((requests, request) => {
            return requests.concat({
              auditPathId: this.pathId || null,
              objectKey: request.objectKey,
            });
          }, []);
          this.changeAuditPaths(payload)
            .then(() => {
              this.loading = false;
              this.$emit('successSubmit');
              this.closeModal();
              this.toaster.success(this.local.changeAuditPath.successMessage);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm () {
      this.pathId = null;
    },
  },
  watch: {
    modalVisibility (newValue) {
      if (newValue) {
        this.callGetAuditPaths();
        this.$refs.modal.show();
      } else {
        this.$refs.modal.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.headline {
  background-color: #075848 !important;
  color: #fff;
  padding: 15px 25px;
}
.change-path-form {
  padding-top: 30px;
}
.modal-content {
  padding: 20px;
}
</style>
